import React, { useState, useEffect } from "react";
import {
    Typography,
    Paper,
    Box,
    Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import Udhariheader from "./Udhariheader";

const db = getFirestore();

const DashboardCard = ({ title, count, color, link }) => (
    <Link to={link} style={{ textDecoration: "none" }}>
        <Paper
            elevation={4}
            sx={{
                height: 130,
                borderRadius: 2,
                p: 2,
                backgroundColor: color,
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                transition: "0.3s",
                cursor: "pointer",
                "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 6,
                    opacity: 0.95,
                },
            }}
        >
            <Box>
                <Typography variant="subtitle1">{title}</Typography>
                <Typography variant="h5" fontWeight="bold">
                    ₹{Number(count).toLocaleString("en-IN")}
                </Typography>
            </Box>
        </Paper>
    </Link>
);

const UsaneHome = () => {
    const [counts, setCounts] = useState({
        totalDene: 0,
        totalJama: 0,
        remaining: 0,
        totalGhene: 0,
        totalGheneJama: 0,
        remainingGhene: 0
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                // ✅ उसने देणे (udhariDene)
                const deneSnapshot = await getDocs(collection(db, "udhariDene"));
                const totalDene = deneSnapshot.docs.reduce((sum, doc) => {
                    const data = doc.data();
                    return sum + Number(data.rakkam || 0) + Number(data.parselofat || 0);
                }, 0);

                // ✅ उसने जमा (udhariJamaHistory)
                const jamaSnapshot = await getDocs(collection(db, "udhariJamaHistory"));
                const totalJama = jamaSnapshot.docs.reduce((sum, doc) => {
                    const data = doc.data();
                    return sum + Number(data.rakkam || 0);
                }, 0);

                const remaining = totalDene - totalJama;


                // ✅ उसने घेणे (udhariGhene)
                const gheneSnapshot = await getDocs(collection(db, "udhariGhene"));
                const totalGhene = gheneSnapshot.docs.reduce((sum, doc) => {
                    const data = doc.data();
                    return sum + Number(data.rakkam || 0);
                }, 0);

                // ✅ उसने घेणे जमा (udhariGheneJamaHistory)
                const gheneJamaSnapshot = await getDocs(collection(db, "udhariGheneJamaHistory"));
                const totalGheneJama = gheneJamaSnapshot.docs.reduce((sum, doc) => {
                    const data = doc.data();
                    return sum + Number(data.rakkam || 0);
                }, 0);

                const remainingGhene = totalGhene - totalGheneJama;


                setCounts({
                    totalDene,
                    totalJama,
                    remaining,
                    totalGhene,
                    totalGheneJama,
                    remainingGhene
                });

            } catch (error) {
                console.log("Error:", error);
            }
        };

        fetchData();
    }, []);

    return (
        <Box>
            <Udhariheader />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", mb: 3 }}>
                उसने डॅशबोर्ड
            </Typography>

            {/* ✅ First Row: उसने देणे */}
            <Grid className="row" spacing={2}>
                <Grid className="col-sm-4" item xs={12} sm={4}>
                    <DashboardCard
                        title="एकूण उसने देणे"
                        count={counts.totalDene}
                        color="#1976d2"
                        link="/finance/udhari/dene"
                    />
                </Grid>

                <Grid className="col-sm-4" item xs={12} sm={4}>
                    <DashboardCard
                        title="एकूण उसने जमा"
                        count={counts.totalJama}
                        color="#2e7d32"
                        link="/finance/udhari/jama"
                    />
                </Grid>

                <Grid className="col-sm-4" item xs={12} sm={4}>
                    <DashboardCard
                        title="शिल्लक उसने देणे"
                        count={counts.remaining}
                        color="#d32f2f"
                        link="/finance/udhari/dene"
                    />
                </Grid>
            </Grid>


            {/* ✅ Second Row: उसने घेणे */}
            <Grid className="row mt-3" spacing={2}>
                <Grid className="col-sm-4" item xs={12} sm={4}>
                    <DashboardCard
                        title="एकूण उसने घेणे"
                        count={counts.totalGhene}
                        color="#6a1b9a"
                        link="/finance/udhari/ghene"
                    />
                </Grid>

                <Grid className="col-sm-4" item xs={12} sm={4}>
                    <DashboardCard
                        title="एकूण उसने घेणे जमा"
                        count={counts.totalGheneJama}
                        color="#00897b"
                        link="/finance/udhari/ghene-jama"
                    />
                </Grid>

                <Grid className="col-sm-4" item xs={12} sm={4}>
                    <DashboardCard
                        title="शिल्लक उसने घेणे"
                        count={counts.remainingGhene}
                        color="#c62828"
                        link="/finance/udhari/ghene"
                    />
                </Grid>
            </Grid>

        </Box>
    );
};

export default UsaneHome;
